import {
  patchProfile,
} from '@zr/utilities/api/profile';

/**
 * Formik submit handler for updating profile
 * @param {string} options.method used in profile_method
 * @param {function} options.onError callback handling all errors besides validation_error
 * @param {function} options.onStart callback ran at the start, useful for clearing previous errors
 * @param {function} options.onSuccess callback ran when successfully updated
 * @param {function} options.onValidationError callback ran when running into a validation_error
 * @param {function} options.transformValidationFieldsStatus optional transform when setting validation fields error, useful for entried data like experience
 * @param {boolean} options.validateOnly set if validate_only desired (the server will only validate the patch, but won't persist it)
 * @returns formik submit handler
 */
export function handleUpdateProfileFormikSubmit({
  method = 'fe.handleUpdateProfileFormikSubmit',
  onError,
  onStart = () => {},
  onSuccess,
  onValidationError = () => {},
  transformValidationFieldsStatus = (fields) => (fields),
  validateOnly = false,
  setIsLoading = () => {},
}) {
  return async (data, { setStatus, setSubmitting }) => {
    onStart();
    try {
      // `setIsLoading(true)` so that we can disable the close button while the
      // screen is processing/loading
      setIsLoading(true);
      const extraParams = {
        profile_method: method,
      };

      if (validateOnly) {
        extraParams.validate_only = true;
      }

      await patchProfile({
        ...data,
        ...extraParams,
      });
      // callback could be async (might call apply endpoint), await keeps isSubmitting true during that
      await onSuccess();
    } catch (error) {
      if (error?.data?.fields && error?.data?.error_code === 'validation_error') {
        setStatus(transformValidationFieldsStatus(error.data.fields));
        onValidationError();
      } else {
        onError(error);
      }
      setSubmitting(false);
    }
  };
}

export default handleUpdateProfileFormikSubmit;
